import { TableHead, TableRow } from '@/components/ui/table';

/** Header row shared by the read-only and edit planned-resource tables. */
const ResourceSectionTableHeader = () => {
  return (
    <TableRow>
      <TableHead className="tw:w-8" />
      <TableHead>Resource</TableHead>
      <TableHead>Leader</TableHead>
      <TableHead># of Persons</TableHead>
      <TableHead>Contact Info</TableHead>
      <TableHead>Reporting Info / Notes</TableHead>
      <TableHead className="tw:w-28" />
    </TableRow>
  );
};

export const RESOURCE_SECTION_COLUMN_COUNT = 7;

export default ResourceSectionTableHeader;
